import { render, staticRenderFns } from "./appt-booking-modal.vue?vue&type=template&id=55870864&scoped=true"
import script from "./appt-booking-modal.vue?vue&type=script&lang=ts"
export * from "./appt-booking-modal.vue?vue&type=script&lang=ts"
import style0 from "./appt-booking-modal.vue?vue&type=style&index=0&id=55870864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55870864",
  null
  
)

export default component.exports